import React from 'react'
import { Box } from '@mui/material'
import { layoutConfigObject } from '../../config'
import { TChildElementProps } from '../../types'
import { useLayoutContext } from '../../Context/LayoutContext'

//this is the website layout component, wrapping all the components as children
export const LayoutBox = ({ children }: TChildElementProps) => {
  //getting the layout selected by context
  const layoutSelected = useLayoutContext()
  //using layout config according to layout selected
  const selectedLayout = layoutConfigObject[layoutSelected]

  return (
    <>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: selectedLayout.gridTemplateColumns,
          columnGap: selectedLayout.columnGap,
          rowGap: selectedLayout.rowGap,
          gridTemplateRows: 'auto',
          gridTemplateAreas: selectedLayout.gridTemplateAreas,
        }}
      >
        {children}
      </Box>
    </>
  )
}
